import React from 'react';
import { Link } from "react-router-dom";
export default function SubHeader({subheadData}) {
  return (
    <>
      <section className="subheader">
        <img src={subheadData.image} className="img-responsive" alt="subheader banner"/>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="subheader-text">
                            <h1 className="heading">{subheadData.pagename}</h1>
                            <p>{subheadData.subhead}</p>
                        </div>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li>/</li>
                            <li>{subheadData.pagename}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </>
);
}




